import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { createRoleFailed, createRoleSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';
import { allRolePermissionKeys } from '../index';

export default function* createRole(action) {
  try {
    const pool = {
      name: action.payload,
      permissions: allRolePermissionKeys.reduce((acc, cur) => { acc[cur] = false; return acc; }, {}),
    };
    const url = `${BACKEND_URL}/api/v1/user/role`;
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    if (dataResponse.status === OK) {
      yield put(createRoleSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(createRoleFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(createRoleFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
